import {
  SET_SETTINGS
} from '../actions/settings'

const INITIAL_STATE = {
  language: navigator.language.startsWith('pt') ? 'pt-BR' : 'en-US'
}

const settingsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_SETTINGS:
      return Object.assign({}, state, action.settings)
    default:
      return state
  }
}

export default settingsReducer



// WEBPACK FOOTER //
// ./src/reducers/settings.js